/**
 * ErrorBoundary — Attrape les erreurs de rendu React
 *
 * Empêche les pages blanches en affichant un message d'erreur
 * et un bouton pour recharger.
 */

import { Component, type ReactNode } from 'react';
import { colors } from '../styles/tokens.js';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div style={{ padding: '48px 24px', maxWidth: 600, margin: '0 auto' }}>
          <div
            style={{
              background: '#fef2f2',
              border: '1px solid #fca5a5',
              borderRadius: 10,
              padding: '24px',
            }}
          >
            <h2 style={{ margin: '0 0 8px', fontSize: 18, color: '#991b1b' }}>
              Une erreur est survenue
            </h2>
            <p style={{ margin: '0 0 16px', fontSize: 14, color: '#7f1d1d', lineHeight: 1.5 }}>
              {this.state.error?.message ?? 'Erreur inconnue'}
            </p>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                onClick={this.handleRetry}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: 6,
                  background: colors.accent,
                  color: '#1a1a1a',
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                Réessayer
              </button>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: 6,
                  background: '#fff',
                  color: colors.text,
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                Recharger la page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
